import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedinIn, FaInstagram, FaPhoneAlt, FaEnvelope, FaBuilding, FaExternalLinkAlt } from 'react-icons/fa';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-page-wrapper">
      {/* Contact Hero Banner Section */}
      <div className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <div className="contact-hero-content">
          <h2>Contact Us</h2>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="contact-content-section">
        <div className="contact-breadcrumb-container">
          <Link to="/" onClick={() => window.scrollTo(0, 0)} className="breadcrumb-home" style={{ textDecoration: 'none' }}>Home</Link>
          <span className="breadcrumb-separator"> / </span>
          <span className="breadcrumb-current">Contact us</span>
        </div>

        {/* The main white card container */}
        <div className="contact-card-box">

          {/* Left Green Panel */}
          <div className="contact-left-panel">
            <div className="left-panel-content">
              <h2>Contact Information</h2>
              <p className="panel-subtitle">Fill up the form and our Team will get back to you within 24 hours.</p>

              <div className="contact-details-list">
                <div className="detail-item">
                  <FaPhoneAlt className="detail-icon" />
                  <a href="tel:+911234567890">+91 9786221122</a>
                </div>
                <div className="detail-item">
                  <FaEnvelope className="detail-icon" />
                  <a href="mailto:ZustGo@gmail.com">ZustGo@gmail.com</a>
                </div>
                <div className="detail-item align-start">
                  <FaBuilding className="detail-icon-building" />
                  <div className="address-lines">
                    <p>22 VKA Nagar</p>
                    <p>1st Floor Ammapettai</p>
                    <p>Chidambaram, Tamil Nadu 608401</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Watermark logo and social icons at the bottom */}
            <div className="left-panel-footer">
              <div className="panel-watermark">
                <img src="/Image/whitesidelogo.png" alt="ZustGo Logo" className="watermark-img" />
              </div>

              <div className="panel-socials">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FaLinkedinIn />
                </a>
                <a href="https://www.instagram.com/zustgo_delivery" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>

          {/* Right Form Panel */}
          <div className="contact-right-panel">
            <h1 className="form-title">
              <span className="green-text">Contact</span> <span className="black-text">ZustGo</span>
            </h1>

            <form className="contact-form-new" onSubmit={(e) => e.preventDefault()}>
              <div className="form-row-single">
                <div className="input-container">
                  <input type="text" placeholder="Name" required />
                  <span className="required-star">*</span>
                </div>
              </div>

              <div className="form-row-single">
                <div className="input-container">
                  <input type="email" placeholder="Email Address" required />
                  <span className="required-star">*</span>
                </div>
              </div>

              {/* Split row for Country Code and Phone Number */}
              <div className="form-row-split">
                <div className="input-container country-code">
                  <input type="text" placeholder="Ex: 91" required />
                </div>
                <div className="input-container phone-number">
                  <input type="tel" placeholder="Phone Number" required />
                  <span className="required-star">*</span>
                </div>
              </div>

              <div className="form-row-single">
                <div className="input-container select-container">
                  <select required defaultValue="">
                    <option value="" disabled hidden>Select Subject</option>
                    <option value="General Inquiry">General Inquiry</option>
                    <option value="Support">Support</option>
                    <option value="Partnership">Partnership</option>
                    <option value="Franchisee">Franchisee</option>
                  </select>
                </div>
              </div>

              <div className="form-row-single">
                <div className="input-container textarea-container">
                  <textarea placeholder="Message" rows="4" required></textarea>
                </div>
              </div>

              <div className="form-submit-row">
                <button type="submit" className="submit-btn-new">Submit</button>
              </div>
            </form>

            {/* Map location embed with absolute overlay */}
            <h4 className="map-title">Our Office Location</h4>
            <div className="contact-map-wrapper">
              <iframe
                title="ZustGo Location Map"
                src="https://www.openstreetmap.org/export/embed.html?bbox=78.465%2C9.838%2C78.495%2C9.860&layer=mapnik"
                width="100%"
                height="220"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
              <a
                href="https://maps.google.com/?q=Aranmanai+Vaasal,+Sivaganga,+Tamil+Nadu"
                target="_blank"
                rel="noopener noreferrer"
                className="open-in-maps-btn"
              >
                Open in Maps <FaExternalLinkAlt className="external-link-icon" />
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Contact;